export default `float s=2., l=0.;
    p=abs(mod(p-1.,2.)-1.);
    for(int j=0;j++<8;)
      p=1.-abs(abs(abs(p-5.)-2.)-2.),
      p*=l=-1.3/dot(p,p),
      p-=vec3(.3,.3,.4), s*=l;
    return length(p.yz)/s;
  }`